<template>
  <div class="wrapper" v-if="loaded">
    <link href="../../screen.css" rel="stylesheet" type="text/css"></link>
    <link href="../../extend-screen.css" rel="stylesheet" type="text/css"></link>
    <link href="../../main.css" rel="stylesheet" type="text/css"></link>
    <!-- なぜかIE11だとダメ
	 <link rel="stylesheet" href="//fonts.googleapis.com/icon?family=Material+Icons"> -->
    <form name="construct" action="" method="post">
      <input type="hidden" name="selectID" :value="$store.state.selectID" />
      <span>&nbsp;</span>
      <div style="position:fixed; z-index:1; right:25px; top:10px;text-align:right; margin-bottom:10px;
		  background-color:#f5efe1;" class="oNav">
	<div style="border:2px outset; padding:3px 3px 3px 3px;">
	  <template v-if="$store.state.evaluation">
	    {{ $t('evaluation') }}
	    <a href="../../construct/priceToTestData.action" style="color:#3673ac;"
	       target="_blank">Data Check/Test/Up</a>
	  </template>
	  <!--  -->
	  <a href="javascript:" @click="goBack" class="link-left" style="color:#3673ac;">{{ $t('goBack') }} </a>
	  <!--  -->
	  <a href="javascript:" @click="toSetup" class="link-right" style="color:#3673ac;">{{ $t(i18n.toSetup) }}</a>
	  <a href="javascript:" @click="toCart" class="cart-put" style="color:#3673ac;">{{ $t(i18n.toCart) }}</a>
	  <!--  -->
	</div>
      </div>

      <div style="position:fixed; z-index:1; right:25px; top:45px; text-align:right;">
	<!-- <div id="loading" style="background:blue; color:white; display:none;">loading...</div> -->
	<div id="errorBoxSwitch" 
	     style="background:white; border:5px double #ccc; "
	     v-show="'errors' in $store.state.checkResult || 'warnings' in $store.state.checkResult" >
	  <md-button style="margin: 0px;" @click.native="toggleBox">
	    <span style="font-weight:bolder; color:red; text-transform:none;"
		  v-if="'errors' in $store.state.checkResult">
	      <md-icon md-src="../static/ic_report_problem_black_18px.svg"></md-icon>
	      {{ $t('errorsExist') }}</span>
	    <span style="font-weight:bolder; color:#3673ac; text-transform:none;"
		  v-else="'warnigs' in $store.state.checkResult">
	      <md-icon md-src="../static/ic_report_problem_black_18px.svg"></md-icon>
	      {{ $t('warningsExist') }}</span>
	  </md-button>
	</div>
	<div id="priceBox" 
	     style="margin-top: 10px;"
	     v-show="'price' in $store.state.checkResult" >
	  <span style="background:white; border:5px double #ccc; padding:3px;">
	    <span style="font-size:100%; font-weight:bolder;">
	      &nbsp; {{ $t('totalPrice') }}
	      <template v-if="'en'==$i18n.locale">{{ this.currencyCode }}</template>&nbsp;
	    </span>
	    <span style="font-size:120%">
	      <span id="price" >{{ $store.state.checkResult.price }}</span>
	      <template v-if="'ja'==$i18n.locale"> 円</template>
	    </span>
	    <span v-if="'ja'==$i18n.locale" style="background:white; font-size:80%;">(税別)</span>
	  </span>
	  <p/>
	</div>
      </div>
      <span style="font-size:70%" v-if="'eight'==siteType">[カートに入れる]をクリックすると見積り/購入相談できます</span>
      
<!-- <h1>Hello</h1> -->
    <h2 class="pkg" style="margin-top:50px;">
      <div style="float: left;">{{ model }} <span v-if="old" style="color:red;">({{ $store.state.status }})</span></div>
      <span v-if="manager"> &nbsp; <a :href="updateTags" target="_blank" class="maintenance">タグ登録</a></span>
      <div v-if="$store.state.enableOptionInfoLink"
	   style="float: left; text-align: left; padding-left: 30px; font-size:small;">
	<a class="link-info" style="color:#3673ac;"
	   @click="toBaseCodeInfo"
	   href="javascript:to_optioninfo('ToBaseCodeInfo.action');">価格・スペック情報確認</a></div>
    </h2>

    <!-- template v-if="isIntranet && (hippakuBody || hippakuStorage || $store.state.inc_N8104_184)" -->
    <template v-if="isIntranet && (hippakuBody || hippakuStorage)">
      <div 
           style="font-weight:bold; color:red; font-size:100%;">
	  <br/>
	  ★重要なお知らせ★（2021年12月15日更新）<br/>
	  半導体逼迫の影響により、下記製品は受注停止いたしました。<br/>
	  <ul>
	    <template v-if="hippakuBody">
	      <!-- <li>Express5800/R110j-1本体</li> -->
              <li>Express5800/T110j, T110j-S, GT110j本体</li>
	      <li>Express5800/T110j-S(映像)本体</li>
	    </template>
            <li v-if="hippakuStorage">iStorage NS100Tj</li>
	    <!-- li v-if="$store.state.inc_N8104_184">10GBASE-T接続ボード(2ch)[N8104-184]</li -->
	  </ul>
	  代替構成など詳細は <a target="_blank" href="https://one.nec.com/post/1346066">https://one.nec.com/post/1346066</a> をご確認ください。
	<!--
	  <br/>
	  ★重要なお知らせ★<br/>
	  半導体逼迫の影響により、製品（本体モデル、オプション製品）によっては納品まで日数を要したり、急遽受注を停止させていただいたりする場合があります。<br/>
	  詳細は パートナー様向けWebサイトに掲載されている通知文でご確認ください。
	-->
      </div>
    </template>
    
    <!-- {{ $store.state.checkResult }} -->
    <template v-for="c,index in children" >
      <!-- <template v-if="'code' == c.nodeName.toLowerCase()">
      </template> -->
      <selection      v-if="'selection' == c.nodeName.toLowerCase()" :el="c">
      </selection>
      <simple-element v-else :el='c'></simple-element>
    </template>

    <div v-show="'' != systemError">
      <dl class="error">
	<dt>System Error</dt>
	<dd>{{ systemError }}</dd>
      </dl>
    </div>
    <!-- debug: <button @click="do_test">ok</button>{{ $route.params.id }}
    <a href="#内蔵ドライブ">test</a> -->
    </form>
    
    <div class="note" 
	 style="position:fixed; z-index:2; left:59%; right:20px; top:120px;">
      <!-- <div align="right">
      </div> -->
      <transition name="fade">
      <dl ref="errorBox" class="error" v-show="$store.state.errorBoxShow">
	<dt>
	</dt>
	<dd>
	  <div style="float:right;">
	    &nbsp;
	    <md-button
	       @click.native="closeBox"
	       style="width:22px; min-width:22px; height:22px; min-height:22px;" class="md-icon-button">
	      <md-icon md-src="../static/ic_close_black_18px.svg" style="font-size:18px;"></md-icon></md-button>
	    <!--
	    <a href="javascript:" onClick="errorBoxToggle(); errorWindow = new ErrorWindow()">
	      <span style="float:right;" class="ui-icon ui-icon-extlink"> </span></a>
	    <a href="javascript:" onClick="errorBoxToggle()"><span style="float:right;" class="ui-icon ui-icon-close"></span></a>
	    <a id="dummy" href="" style="display:none"><span style="float:right;" class="ui-icon ui-icon-check"></span></a>
	    -->
	  </div>
	  <ul id="errorList">
	    <li v-for="info,key in $store.state.checkResult.errors">{{ key }}
	      <template v-for="section in info">
		<a :href="'#'+section"
		   v-if="sectionExist(section)"
		   class="section_link"
		   style="text-decoration:none; border:none; color: #3673ac;"
		   onmouseover="this.style.color='#ff7f50'"
		   onmouseout="this.style.color='#3673ac'">
		  <img :title="section+'へ'"
		       style="padding-bottom: 3px; vertical-align: bottom;"
		       src="../../static/icon_flink.gif" >
		  {{ section }}
		</a>
	      </template>
	      <template v-for="section in info">
		<template v-if="!sectionExist(section)" >
		  {{ section }}
		</template>
	      </template>
	    </li>
	  </ul>
	</dd>
      </dl>
      </transition>
      <dl ref="warningBox" class="warning" v-show="$store.state.warningBoxShow">
	<dt>
	  <div style="float:right; _text-align:right; font-size:120%;">
	    &nbsp;
	    <md-button
	       @click.native="closeBox"
	       style="width:22px; min-width:22px; height:22px; min-height:22px;" class="md-icon-button">
	      <md-icon md-src="../static/ic_close_black_18px.svg" style="font-size:18px;"></md-icon></md-button>
	    <a href="javascript:" onClick="errorBoxToggle(); errorWindow = new ErrorWindow()">
	      <span style="float:right;" class="ui-icon ui-icon-extlink"> </span></a>
	    <a href="javascript:" onClick="errorBoxToggle()"><span style="float:right;" class="ui-icon ui-icon-close"></span></a>
	    <a id="warning_check_ok" href="javascript:" onClick="to_cart()" style="display:none"><span style="float:right;" class="ui-icon ui-icon-check"></span></a>
	    <a id="dummy" href="" style="display:none"><span style="float:right;" class="ui-icon ui-icon-check"></span></a>
	  </div>
	  {{ $t('warnings') }}
	</dt>
	<dd>
	  <ul id="warningList">
	    <li v-for="info,key in $store.state.checkResult.warnings">{{ key }}{{ info }}</li>
	  </ul>
	</dd>
      </dl>
    </div>

<div id="toc" class="note"
     style="padding:7px; border:solid 1px;
            position:absolute; z-index:1; left:0px; top:0px; 
            background-color: white; display:none;">
  <!--
      <a href="javascript:" onClick="$('toc').style.display='none'">
	<span style="float:right;" class="ui-icon ui-icon-close"></span>
      </a>
      -->
      <md-button
	 @click.native="closeToc"
	 style="float:right; width:22px; min-width:22px; height:22px; min-height:22px;"
	 class="md-icon-button">
	<md-icon md-src="../static/ic_close_black_18px.svg" style="font-size:18px;"></md-icon></md-button>

      <template v-for="sec in this.$store.state.section">
	<a :href="'#'+sec" @click="closeToc"
	   style="color: #3673ac;"
	   onMouseOver="this.style.borderBottom = 'none'">{{ sec }}</a><br/>
      </template>

</div>

    <md-dialog ref="oldAlert">
      <div class="warning">
      <!-- <md-dialog-title>Result</md-dialog-title> -->
      <md-dialog-content style="font-weight:bold; font-size:150%;">
	旧モデルの詳細選択ページです。<br/>このページでは新規オプション等のメンテナンスを実施しておりません。
      </md-dialog-content>
      <md-dialog-actions>
	<md-button class="md-primary" @click.native="closeDialog('oldAlert')">OK</md-button>
      </md-dialog-actions>
      </div>
    </md-dialog>
    <md-snackbar md-position="bottom center" ref="snackbar" :md-duration="$store.state.snackbar.duration">
    <span>{{ $t($store.state.snackbar.message) }}</span>
      <md-button class="md-accent" md-theme="light-blue" @click.native="$refs.snackbar.close()">OK</md-button>
    </md-snackbar>
  </div>
</template>
<script>
// axiosはIE11で動作がおかしい
//require('es6-promise').polyfill()
//import axios from 'axios'
var $ = require('jquery')

import SimpleEl from '@/components/SimpleElement'
import Selection from '@/components/Selection'

export default {
    props: ['reSelect'], 
    data() {
	return {
	    model: '',
	    // status: '',
	    // selectID: 0, ...timeout対策の為、storeで保存するよう変更
	    children: [
	    ],
	    /* storeで管理
	    section: [{
		title: 'CPU'
	    }], */
	    //loading: true //初回描画時のみ金額計算させたい為
	        // =>  ...timeout対策の為、storeで管理
	    //checkResult: priceCheckStore.state
	    systemError: '',
	    siteType: 'intranet',
	    i18n: {
		toSetup: 'toSetup',
		toCart: 'toCart'
	    },
	    currencyCode: '円',
	    manager: false
	}
    },
    computed: {
	old: function() {
	    return ('旧' == this.$store.state.status)
	},
	updateTags: function() {
	    return "../../updateTags.action?id=" + this.$store.state.mdfId
	},
	loaded: function() {
	    return (0 != this.$store.state.selectID)
	},
	isIntranet: function() {
	    return 'intranet'==this.siteType ||
		'Beat'==this.siteType ||
		'EOSS'==this.siteType ||
		'prospect'==this.siteType
	},
	hippakuBody: function() {
	    return this.model.startsWith('Express5800/R110j-1 ') ||
		this.model.startsWith('Express5800/T110j ') ||
		this.model.startsWith('Express5800/T110j-S') ||
		this.model.startsWith('Express5800/GT110j ')
	},
	hippakuStorage: function() {
	    return "iStorage NS100Tj"==this.model
	}
    },
    /* watch: {
	status: function(newStatus) {
	    console.log('status: ', newStatus)
	    this.$refs['oldAlert'].open()
	}
    }, */
    methods: {
	do_test(event) {
	    event.preventDefault()
	    //console.log("checkResult:",this.checkResult)
	    //console.log("store:",priceCheckStore.state)
	    //console.log("this:",this)
	},
	toBaseCodeInfo() {
	    window.open("../../ToBaseCodeInfo.action",
			"_blank",
			"width=800,height=500,resizable=yes,scrollbars=yes")
	},
	goBack() {
	    /* if(document.referrer.endsWith('newServer.action')) {
		history.back()
		return
	    } */
	    const fm = document.construct;
	    const action = fm.action;
	    fm.action="../../construct/GoBack.action";
	    fm.submit();
	    fm.action = action;
	},
	toSetup(e) {
	    // console.log(e.target)
	    this.checkAndGo("../../construct/ToSetup.action",e)
	    /* this.checkAndGo(() => {
		const fm = document.construct;
		const action = fm.action;
		fm.action="../../construct/ToSetup.action";
		fm.submit();
		fm.action = action;
	    }); */
	},
	toCart(e) {
	    this.checkAndGo("../../construct/ToCart.action",e)
	    /* this.checkAndGo(() => {
		const fm = document.construct;
		const action = fm.action;
		fm.action="../../construct/ToCart.action";
		fm.submit();
		fm.action = action;
	    }) */
	},
	checkAndGo(goUrl,evt) {
	    if(this.retainSession()) {
		// alert('セッションタイムアウトしました');
		return
	    }
	    const state = this.$store.state
	    let isConfirm = false
	    if('errors' in state.checkResult) {
		state.errorBoxShow = true
		isConfirm = true
	    }
	    if(('warnings' in state.checkResult) && !state.warningBoxShow ) {
		state.warningBoxShow = true
		isConfirm = true
	    }
	    if (isConfirm) {
		$('#errorBoxSwitch').hide();
		$('#errorBoxSwitch').slideDown(500);
	    } else {
		evt.target.style.cursor = 'wait';
		document.body.style.cursor = 'wait';
		//coreFunc();
		const fm = document.construct;
		const action = fm.action
		fm.action= goUrl
		fm.submit();
		fm.action = action
	    }
	},
	retainSession() {
	    //console.log("retainSession")
	    let parameters = "option_0=NULL"
	    parameters += "&priceCode=NULL"
	    parameters += "&option_0=NULL"
	    parameters += "&key=option_0"
	    $.ajax({
		url: '../../ValsInfo.action',
		type: 'post',
		async: false,
		data: parameters,
		dataType: "json",
		success: (res) => {
		    if(res.timeout) {
			console.log("timeout")
			this.$store.dispatch("rebuildSession")
			// stateでの再描画前にsubmitされてしまうので、ここで強制的に書き換える
			// document.construct.selectID.value = this.$store.state.selectID
		    }
		},
		error: (xhr,status,err) => {
		    console.log(err)
		    alert(err)
		}
	    })
	    //console.log("selectID",document.construct.selectID.value)
	    
	    return (document.construct.selectID.value != this.$store.state.selectID)
	},
	/* toSetup() {
	    const fm = document.construct;
	    const action = fm.action;
	    fm.action="../../construct/ToSetup.action";
	    fm.submit();
	    fm.action = action;
	}, */
	closeDialog(ref) {
	    this.$refs[ref].close();
	},
	closeBox() {
	    this.$store.state.errorBoxShow = false
	    this.$store.state.warningBoxShow = false
	},
	toggleBox() {
	    const state = this.$store.state
	    state.errorBoxShow = ('errors' in state.checkResult) && !state.errorBoxShow
	    state.warningBoxShow = ('warnings' in state.checkResult) && !state.warningBoxShow
	},
	sectionExist(section) {
	    return (document.getElementById(section) != null)
	},
	closeToc() {
	    $('#toc').fadeOut(300)
	}
    },
    beforeMount() {
	//console.log("mdf: boforeMount")
	// i18n
	const en = this.$i18n.getLocaleMessage("en")
	const ja = this.$i18n.getLocaleMessage("ja")
	en.goBack = "Back"
	en.toSetup = "Next"
	en.toCart = "Add to Cart"
	en.totalPrice = "Total Price"
	en.errorsExist = "Your configuration is NOT supported. [Show/Hide messages]"
	en.warningsExist = "There are WARNING messages. [Show/Hide messages]"
	en.warnings = "Warnings"
	en.retrievingCart = "Your session has timed out. Retrieving your last saved cart..."
	en.cartRetrieved = "Your cart has been retrieved."
	ja.goBack = "戻る"
	ja.toSetup = "次へ"
	ja.toCart = "カートに入れる"
	ja.totalPrice = "希望小売価格"
	ja.errorsExist = "選択された構成に問題があります [表示/非表示切替]"
	ja.warningsExist = "注意事項があります [表示/非表示切替]"
	ja.warnings = "注意事項"
	ja.retrievingCart = "セッションタイムアウトしました。カートに保存されていた内容を復元中..."
	ja.cartRetrieved = "カートを復元しました"
	//ja_JP_Direct.toSetup = "構成品一覧"
	ja.Direct = {
	    "toSetup": "構成品一覧",
	    "toCart": "得選街カートへ"
	}
	this.$i18n.setLocaleMessage("en",en)
	this.$i18n.setLocaleMessage("ja",ja)
	//this.$i18n.setLocaleMessage("ja_JP_Direct",ja_JP_Direct)

	// タイムアウト対策として、idを保存しておく
	this.$store.commit("setMdfId",this.$route.params.id.replace(/--/,"/"))
	//if(window.navigator.userAgent.toLowerCase().indexOf("msie") >= 0)
	//    this.errorBoxSwitchTop = "30px"
	
	/* axios version... IE11で動きがあやしい
	axios.get('/static/mdf_sample.xml', {})
	    .then(res => {
		let dom = $(res.data)
		//console.log(dom)
		this.model = dom.find("model").text()
		dom.children().each((index,el) => {
		    if(index > 0) {
			this.children.push(el)
			// console.log($(el).text())
		    }
		})
		//this.$set(this.data, 'model',  dom.find("reply jcid").text())
	    })
	    .catch(error => {
		alert(error)
	    })
	*/
	//console.log('props',this.$props)
	let mdfUrl = '../../Mdf.action?id='+this.$store.state.mdfId
	/*
	mdfUrl += "&referer="+document.referrer
	if(this.$props.h)
	    mdfUrl+="&h="+encodeURI(this.$props.h) */
	if(this.$props.reSelect)
	    mdfUrl += "&reSelect=true"
	//console.log("mdfUrl", mdfUrl)
	$.ajax({
	    //url: '../static/mdf_sample.xml',
	    url: mdfUrl,
	    // async: false,  // locale取得後に画面を書き換えると、再描画が頻発する為
	    cache: false,  // IEではこれを指定しておかないと動きがおかしくなる
	    dataType: 'xml',
	    success: (data) => {
		const dom = $(data)
		const model2 = dom.find("model2").text()
		if(model2.length > 0)
		    this.model = model2
		else
		    this.model = "Express5800/" + dom.find("model").text()

		/**** loopはサーバサイドで処理
		dom.find("loop").each((index, el) => {
		    const cnt = $(el).attr("count")
		    const rep = $('<span>')
		    for(let i=0; i<cnt; i++) {
			rep.append( $(el).clone().children() )
		    }
		    $(el).replaceWith(rep)
		}) ****/

	        let selects = dom.find("select")
		for(let i=(selects.length-1); i>=0; i--) {
		    let sel = selects[i]
		//dom.find("select").each((i,sel) => {
		    //if(!sel.hasAttribute('name'))
		    //  sel.setAttribute('name','option_'+i)
		    const c = $(sel).find("custom")
		    //console.log(sel.getAttribute("name"), c)
		    if(c.length > 0) {
			let t
			if("tabs" == sel.getAttribute("implement")) 
			    t = $('<custom-tabs>')
			else
			    t = $('<custom-select>')
			const bk  = $('<blockquote>')
			//$(sel).after( bk )
			c.each((j,cus) => {
			    //$(cus).parent().attr('value')
			    const d = $('<div>').attr('value',$(cus).parent().attr('value'))
			    //d.attr('style','display:none')
			    //d.attr('slot',$(cus).parent().attr('value'))
			    //console.log( $(cus) )
			    //d.html( $(cus).html().replace(/<!--[\s\S]*-->/g,'') )
			    //d.html( $(cus).html() )
			    d.append( $(cus).clone()[0].childNodes )
			    //d.append( $(cus).clone().children() )
			    bk.append(d)

			    $(cus).remove()
			})
			//$(sel).attr('slot','option')
			t.append( $(sel).clone() )
			t.append( bk )
			$(sel).replaceWith(t)
		    }
		}
		/**** selectタグのナンバリングはサーバサイドで処理
		dom.find("select").each((i,sel) => {
		    if(!sel.hasAttribute('name'))
			sel.setAttribute('name','option_'+i)
		}) ****/
		    
		//dom.find("custom").remove()
		//console.log(dom.children())
		//console.log("mdf:",dom.find("mdf")[0].getAttribute("selectID"))
		const mdf = dom.find("mdf")[0]
		this.manager = ('true' == mdf.getAttribute("manager"))
		this.siteType = mdf.getAttribute("siteType")
		this.currencyCode = mdf.getAttribute("currencyCode")
		// const lang = mdf.getAttribute("lang")
		this.$i18n.locale = mdf.getAttribute("lang")
		if("Direct"==this.siteType) {
		    this.i18n.toSetup = 'Direct.toSetup'
		    this.i18n.toCart = 'Direct.toCart'
		}
		this.$store.state.selectID = mdf.getAttribute("selectID")
		this.$store.state.enableOptionInfoLink = ('true' == mdf.getAttribute("enableOptionInfoLink"))
		this.$store.state.evaluation = ('true' == mdf.getAttribute("evaluation"))
		this.$store.state.status = mdf.getAttribute("status")
		// this.status = mdf.getAttribute("status")
		dom.find("mdf").children().each((index,el) => {
		    if(index > 1) { // model, codeを飛ばす
			this.children.push(el)
			//console.log(el.nodeName)
		    }
		})
		//console.log("mdfLoad: true")
		this.$store.commit('setMdfLoad',true)
	    },
	    error: (xhr,status,err) => {
		// alert("Error: "+this.$route.params.id+"\n"+err)
		console.log("xhr:",xhr)
		console.log("status:",status)
		console.log("err:",err)
		const s_idx = xhr.responseText.indexOf("<pre>")
		const e_idx = xhr.responseText.indexOf("</pre>")
		this.systemError = xhr.responseText.substring(s_idx+5, e_idx)
		this.$store.state.selectID = 1
	    }
	})
    },
    mounted() {
	//console.log("mdf: mounted")
	//if(this.old) this.$refs['oldAlert'].open()
	//this.loaded = true
    },
    updated() {
	//console.log("mdf: updated")
	if(this.$store.state.mdfLoad && !this.$store.state.mdfLoading) {
	    //console.log("mdf: loading...checkPrice")
	    //this.$store.commit('setMdfLoad',false)
	    this.$store.dispatch("checkPrice")
	    
	    if(this.$store.state.refs == null) {
		// console.log("snackbar", this.$refs.snackbar)
		this.$store.state.refs = this.$refs
	    }
	}
    },
    components: {
	'simple-element': SimpleEl,
	'selection': Selection
    }
}
</script>
<style>
#main {
  text-align: left;
}
#main input:disabled {
  color: black;
  background-color: white;
}
.warning{border:1px solid #593D00; background:url(../../static/icon_warning.gif) no-repeat 5px center; padding:5px 5px 5px 42px;color:#593D00;}
						  
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0
							    }
							    
.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-out .5s;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes bounce-out {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(0);
  }
}
</style>



// WEBPACK FOOTER //
// Mdf.vue?6b78548c